import React from 'react';
import './BImplementation.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

// Recibimos la prop 'id' para que el scroll-to-section funcione.
function BImplementation({ id }) {
  return (
    // 🩹 CIRUGÍA: Clase "implementation-section" renombrada a "b-implementation-section"
    <section className="b-implementation-section" id={id || 'implementation'}>
      <div className="container">
        <h2 className="section-title">
          Implementación Ágil. <span className="highlight-blue">Soporte Dedicado.</span>
        </h2>
        <p className="section-subtitle">Eliminamos la fricción de la capacitación corporativa</p>
        
        <div className="implementation-grid">
          <div className="implementation-card">
            <div className="implementation-icon">🚀</div>
            <h3 className="implementation-title">Onboarding</h3>
            <p className="implementation-description">
              Deja el onboarding en nuestras manos: integración de equipos por áreas, configuración de accesos, reportes gerenciales y SSO. Tu equipo estará activo y aprendiendo esta misma semana.
            </p>
          </div>

          <div className="implementation-card">
            <div className="implementation-icon">📈</div>
            <h3 className="implementation-title">Diagnóstico Preciso (MCERL)</h3>
            <p className="implementation-description">
              Empezamos con un placement test que mapea a cada empleado al nivel 
              MCERL correcto (A1-C2). Las rutas de aprendizaje y la asignación de profesores 
              son personalizadas desde el Día 1.
            </p>
          </div>

          <div className="implementation-card">
            <div className="implementation-icon">💬</div>
            <h3 className="implementation-title">Soporte Prioritario</h3>
            <p className="implementation-description">
              Asignamos un canal directo para tu empresa. Tienes acceso prioritario a tu 
              Account Manager y a soporte técnico para resolver dudas al instante.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BImplementation;
